import {FaCaretLeft} from "react-icons/fa";

import style from "./style.module.scss";

interface props {
    text: string;
    className?: string;
    action: any;
}

function BackButton({className, text, action}: props) {

    return (
        <div className={style.root + " " + (className ? className : "")} onClick={action}>
            <div className="arrow-container" style={{width: "200px"}}>
                <h4 style={{color: "black!important", fontWeight: "lighter", fontSize: "20px"}} className={style.textCnt + " ml-2 mb-1"}><FaCaretLeft size="22" />{text}</h4>
                <hr className={style.topHr1 + " text-left mb-0 ml-3 mt-0"} />
                <hr className={style.topHr2 + " text-left mt-0 ml-3 mb-0"} />
            </div>
        </div>
    );
}

export default BackButton;